import { Button } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';

export const UnlinkVendorCommandCell = (props: GridCellProps | any) => {
  return (
    <td>
      <Button variant="outlined" color="error" size="small" onClick={() => props.unlinkVendor(props.dataItem)}>
        Unlink
      </Button>
    </td>
  );
};
